/**
 * Pretty messages to show the user based on status code
 */
export const ERROR_STATUS_MESSAGES = {
  400: 'Your request resulted in an error.',
  404: 'We could not find the page you were looking for.',
  500: 'An error occurred, that we could not foresee.',
};

export const getError = error => {
  return {
    statusCode: error?.response?.status,
    ...error?.response?.data,
  };
};

export const PL_NUMBER_INVALID_MESSAGE =
  'PL numbers must use the format PL-XXXXXXX, PL-OTHER or PL-OVERAGE.';

// Matches a JIRA issue key: an uppercase project key (letter, then letters or
// digits — e.g. CGO, PRODISSUE, ABC2) followed by an issue number. Each team
// has its own project, so this must not be hardcoded to specific keys.
export const JIRA_KEY_RE = /^[A-Z][A-Z0-9]+-\d+$/;
export const JIRA_INVALID_MESSAGE = 'Enter a valid ticket (e.g. CGO-1234)';

export const END_DATE_NOT_AFTER_START_DATE_MESSAGE =
  'The end date must be after the start date.';

export const END_DATE_MUST_BE_IN_FUTURE =
  'Please select an end date in the future.';

export const QUOTA_MUST_BE_ABOVE_ZERO = 'Please enter a positive quota.';

export const formatErrorMsg = error => {
  // Prefer field-level validation errors over the generic wrapper message
  if (error?.errors) {
    const fieldMessages = Object.values(error.errors)
      .flat()
      // Field errors are usually strings (marshmallow: {field: ["msg"]}), but
      // some endpoints return richer objects ({CODE: {message, ...}}). Pull the
      // human-readable message off those rather than stringifying the object to
      // "[object Object]".
      .map(v => (typeof v === 'string' ? v : v?.message))
      .filter(Boolean);
    if (fieldMessages.length) return fieldMessages.join(' ');
  }
  return [error?.message, error?.body?.message].filter(m => m).join(': ');
};
